<script>
  import Logo from '@/components/atoms/Logo'

  export default {
    name: 'HimekuriCover',
    data: function() {
      return {
        isTurnTo: false,
        isTurnFrom: false,
        timer: null,
      }
    },
    components: {
      Logo
    },
    mounted() {
      this.timer = setInterval(() => {
        this.isTurnTo = true;
        this.isTurnFrom = false;
        setTimeout(() => {
          this.isTurnFrom = true;
          this.isTurnTo = false;
        }, 1900);
      }, 2800);
    },
    methods: {
      click(e) {
        clearInterval(this.timer);
        this.$emit('click', e);
      }
    },
  }
</script>

<template lang="pug">
  transition(
    name = 'himekuri-cover'
    )
    .himekuri-cover(
      @click = 'click'
      )
      Logo.himekuri-cover__logo(
        color = '#E60010'
        )
      .himekuri-cover__text
        |画面をタップして
        br.brNoto
        |今日のクエスチョンをめくろう！
      .himekuri-cover__edge
        .himekuri-cover__edge-in(
          :class = "{ 'himekuri-turn-to': isTurnTo, 'himekuri-turn-from': isTurnFrom, }"
          )
</template>

<style lang="scss">
  .himekuri-cover {
    width: 100%;
    height: 100%;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    left: 0;
    overflow: hidden;
    &__logo {
      width: 235px;
      height: 104px;
      margin-bottom: 10px;
    }
    &__text {
      text-align: center;
      color: $primary-color;
      @include fontSize(16);
      font-weight: 700;
    }
    &__edge {
      width: 24px;
      height: 24px;
      position: absolute;
      bottom: 0;
      right: 0;
      &-in {
        width: 100%;
        height: 100%;
        overflow: hidden;
        &:after {
          width: 100%;
          height: 100%;
          content: '';
          display: block;
          background-color: #ddd;
          transform-origin: right top;
          transform: skewX(-45deg);
        }
      }
    }

    //
    // 表示・非表示アニメーション
    &.himekuri-leave-to {
      transition-duration: 0.65s;
    }
    &__logo {
      .himekuri-leave-to & {
        opacity: 0;
        transition-duration: 0.2s;
        transition-delay: 0.35s;
      }
    }
    &__text {
      .himekuri-leave-to & {
        opacity: 0;
        transition-duration: 0.2s;
        transition-delay: 0.35s;
      }
    }
    &__edge {
      .himekuri-leave-to & {
        width: 705px;
        height: 705px;
        transition-duration: 0.65s;
        transition-timing-function: $easeInQuart;
      }
    }

    // クリック誘導アニメーション
    &__text {
      animation: blink 2s infinite ease;
    }
    &__edge-in {
      transform-origin: right bottom;
    }
    &__edge-in.himekuri-turn-to {
      transition-delay: 1.2s;
      transition-duration: .7s;
      transform: scale(1.6667, 1.6667);
      transition-timing-function: $easeOutCubic;
    }
    &__edge-in.himekuri-turn-from {
      transition-delay: .1s;
      transition-duration: .8s;
      transform: scale(1, 1);
      transition-timing-function: $easeOutCubic;
    }
  }
  @keyframes blink {
    0% {
      opacity: 0.2;
    }
    50% {
      opacity: 1;
    }
    100% {
      opacity: 0.2;
    }
  }
</style>
